import React, { Component } from 'react';

import './Projects.css';

import { background_4 } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import DSIIssues from '../../components/DSIIssues/DSIIssues';
import Tabs from '@acri-tools/react-tools/components/Tabs/Tabs';
import request from '@acri-tools/react-tools/utils/request';
import { axiosErrorHandler, create_toast, isAdmin, nullUndefined, push_history, toast_request_error } from '@acri-tools/react-tools/utils';
import { API_URL, get_page_title } from '../../utils/config';
import classNames from 'classnames';
import LoadingData from '../../components/LoadingData/LoadingData';
import { ModalClose } from '@acri-tools/react-tools';
import Modal from '@acri-tools/react-tools/components/Modal/Modal';
import CreateProject from '../../components/CreateProject/CreateProject';
import UpdateProject from '../../components/UpdateProject/UpdateProject';
import {
    format_project_data,
    get_percentage_color,
    PROJECT_PROCESSING_HEADERS,
    PROJECT_PACKAGING_HEADERS
} from '../../utils/projects';
import DataTable from '../../components/DataTable/DataTable';
import { Helmet } from 'react-helmet';

// https://xpress.sp.serco.eu

interface Props {
}
interface State {
    create_modal: boolean
    loading: boolean

    update?: any,

    planned_data?: any,
    ongoing_data_processing?: any,
    ongoing_data_packaging?: any,
    completed_data_processing?: any,
    completed_data_packaging?: any,
}

class Projects extends Component<Props, State>{

    constructor(props: Props) {
        super(props);
        this.state = {
            create_modal: false,
            loading: false,
        }
    }

    componentDidMount() {
        this.fetch(true);
    }
    fetch = async (load?: boolean) => {
        if (load) this.setState({ loading: true });
        try {
            let res = await request(`${API_URL}/api/v1/projects`, {
                method: 'get',
                params: {
                    count: true,
                    limit: "null"
                }
            })

            let ongoing_data = [];
            let planned_data = [];
            let completed_data = [];

            for (let p of res.data.value) {
                format_project_data(p);
                switch (p.status) {
                    case 'ongoing':
                        ongoing_data.push(p);
                        continue;
                    case 'planned':
                        planned_data.push(p);
                        continue;
                    case 'completed':
                        completed_data.push(p);
                        continue;
                }
            }

            const ongoing = this.splitToTypes(ongoing_data);
            const completed = this.splitToTypes(completed_data);

            this.setState({
                ongoing_data_processing: ongoing.processing,
                ongoing_data_packaging: ongoing.packaging,
                completed_data_processing: completed.processing,
                completed_data_packaging: completed.packaging,
                planned_data
            });
        }
        catch (e) {
            axiosErrorHandler(e, { functionName: `fetch` });
            toast_request_error(e);
        }
        finally {
            if (load) this.setState({ loading: false })
        }
    }

    splitToTypes = (data: any) => {
        let processing = [];
        let packaging = [];

        for (let d of data) {
            switch (d.type) {
                case 'processing':
                    processing.push(d);
                    continue;
                case 'packaging':
                    packaging.push(d);
                    continue;
            }
        }

        return { processing, packaging };
    }

    percentage_column = (p: any, col: string) => (
        <td
            className={get_percentage_color(p[col])}
        >
            <div
                className={classNames({
                    "project-percentage": true,
                    "no-data": nullUndefined(p[col]),
                    "project-percentage-large-option": (col === 'consolidation' || col === 'update')
                })}
            >
                {nullUndefined(p[col]) ? 'N/A' : `${p[col]}%`}
            </div>
        </td>
    )

    date_column = (p: any, col: any) => (
        <div className="project-date">
            {this.get_date_format(p[col])}
        </div>
    )

    percentage_size = '75px'


    show_projects = (projects: Array<any> | undefined | null, date: { col1: string, name1: string, col2: string, name2: string }) => {
        const allHeaders = [{
            label: 'Project',
            key: 'name'
        },
        {
            label: date.name1,
            key: date.col1
        },
        {
            label: date.name2,
            key: date.col2
        },
        {
            label: 'Extraction',
            key: "extraction"
        },
        {
            label: 'Collection',
            key: "collection"
        },
        {
            label: 'Consolidation / Completeness check',
            key: "consolidation"
        },
        {
            label: 'Integration',
            key: "integration"
        },
        {
            label: 'Tool Development / Update',
            key: "update"
        },
        {
            label: 'Processing',
            key: "processing"
        },
        {
            label: 'Packaging',
            key: "packaging"
        },
        {
            label: 'Repatriation',
            key: "repatriation"
        }
        ];

        const filter = projects?.[0]?.type === 'packaging' ? PROJECT_PROCESSING_HEADERS : projects?.[0]?.type === 'processing' ? PROJECT_PACKAGING_HEADERS : [];

        if (filter.length > 0) {
            let headers = allHeaders.filter((header) => !filter.includes(header.key));

            return <LoadingData loading={this.state.loading} no_data={!projects} no_data_message="No projects to show">
                {
                    projects &&
                    <DataTable
                        show_all
                        data={projects}
                        fixed_width={{
                            'collection': this.percentage_size,
                            'consolidation': this.percentage_size,
                            'integration': this.percentage_size,
                            'processing': this.percentage_size,
                            'repatriation': this.percentage_size,
                            'extraction': this.percentage_size,
                            'update': this.percentage_size,
                            'packaging': this.percentage_size,
                        }}
                        headers={headers}
                        field_output={{
                            'name': (p) => <div
                                className="project-name"
                                onClick={() => { push_history(`/project/${p.name}`) }}
                            >
                                {p.name}
                            </div>,
                            'planned_completion_date': (p) => this.date_column(p, date.col2),
                            'completion_date': (p) => this.date_column(p, date.col2),
                            'start_date': (p) => this.date_column(p, date.col1),
                            'collection': (p) => this.percentage_column(p, 'collection'),
                            'consolidation': (p) => this.percentage_column(p, 'consolidation'),
                            'integration': (p) => this.percentage_column(p, 'integration'),
                            'processing': (p) => this.percentage_column(p, 'processing'),
                            'repatriation': (p) => this.percentage_column(p, 'repatriation'),
                            'extraction': (p) => this.percentage_column(p, 'extraction'),
                            'update': (p) => this.percentage_column(p, 'update'),
                            'packaging': (p) => this.percentage_column(p, 'packaging')
                        }}
                        operations={isAdmin() ? this.get_operations : undefined}
                        sort_columns={{
                            'name': { filter: 'alphabetical' },
                            'planned_completion_date': { filter: 'date' },
                            'completion_date': { filter: 'date' },
                            'start_date': { filter: 'date' },
                            'collection': { filter: 'numerical' },
                            'consolidation': { filter: 'numerical' },
                            'integration': { filter: 'numerical' },
                            'processing': { filter: 'numerical' },
                            'repatriation': { filter: 'numerical' },
                            'extraction': { filter: 'numerical' },
                            'update': { filter: 'numerical' },
                            'packaging': { filter: 'numerical' },
                        }}
                    />
                }
            </LoadingData>
        }
    }

    get_date_format = (date?: string) => {
        // Return the date in format Jun 10 2022 without the week day displayed by default (Fri Jun 10 2022)
        return date && new Date(date).toDateString?.().split(' ').slice(1).join(' ');
    }

    get_operations = (project: any) => {
        return (
            <div className="table-operations">
                <div
                    className="custom-button icon-only blue inline small inverted alt tt"
                    onClick={() => {
                        this.setState({ update: project })
                    }}
                >
                    <i className="fas fa-pen" />
                    <div className="tt-tooltip">update</div>
                </div>
                <div
                    className="custom-button icon-only red inline small inverted alt tt"
                    onClick={() => {
                        this.delete(project)
                    }}
                >
                    <i className="fas fa-times" />
                    <div className="tt-tooltip">delete</div>
                </div>
            </div>
        )
    }

    getTab = (data: any, title: string, col2: string, name2: string): JSX.Element => {
        return <div className="tab-padding">
            {
                data?.length > 0
                &&
                <>
                    <h1 className="title-4">{title}</h1>
                    {
                        this.show_projects(data, { col1: 'start_date', name1: 'Start date', col2, name2 })
                    }
                </>
            }
        </div>
    }

    render() {
        return (
            <Page
                id="projects"
                banner={{
                    title: "projects",
                    bannerImage: background_4,
                    topBar: true
                }}
                footer
            >
                <Helmet>
                    <title>{get_page_title(`DAMPS - Projects`)}</title>
                    <meta
                        name="description"
                        content="All DAMPS projects"
                    />
                </Helmet>
                <div className="page-content">
                    <div className="centered-content padding">
                        {
                            isAdmin() &&
                            <>
                                {/* ==============================
                                CREATE 
                                ============================== */}
                                <div
                                    className="custom-button blue inline medium"
                                    onClick={() => { this.setState({ create_modal: true }) }}
                                >
                                    <i className="fas fa-plus" /> ADD PROJECT
                                </div>
                                <br />
                                <br />

                                <Modal
                                    className="medium"
                                    opened={this.state.create_modal}
                                    close={() => { this.setState({ create_modal: false }) }}
                                >
                                    <div className="modal-title">
                                        ADD NEW PROJECT <ModalClose close={() => { this.setState({ create_modal: false }) }} />
                                    </div>
                                    <div className="modal-content">
                                        <CreateProject
                                            onCreate={() => {
                                                // this.fetch_data();
                                                this.setState({ create_modal: false });
                                                this.fetch();
                                            }}
                                        />
                                    </div>
                                </Modal>



                                {/* UPDATE */}
                                {
                                    this.state.update &&
                                    <Modal
                                        className="medium"
                                        opened={!!this.state.update}
                                        close={() => { this.setState({ update: undefined }) }}
                                    >
                                        <div className="modal-title">
                                            UPDATE PROJECT <ModalClose close={() => { this.setState({ update: undefined }) }} />
                                        </div>
                                        <div className="modal-content">
                                            <UpdateProject
                                                project={this.state.update}
                                                onUpdate={() => {
                                                    this.fetch();
                                                    this.setState({ update: undefined });
                                                }}
                                            />
                                        </div>
                                    </Modal>
                                }
                            </>
                        }
                        <Tabs
                            tabs={[
                                {
                                    label: <><i className="fas fa-sync" /> Ongoing Projects</>,
                                    content: <>
                                        {
                                            this.getTab(this.state.ongoing_data_processing, '(Re)Processing', 'planned_completion_date', 'Planned completion date')
                                        }
                                        {
                                            this.getTab(this.state.ongoing_data_packaging, 'Packaging/Formatting', 'planned_completion_date', 'Planned completion date')
                                        }
                                    </>
                                },
                                {
                                    label: <><i className="fas fa-check-circle" /> Completed Projects</>,
                                    content: <>
                                        {
                                            this.getTab(this.state.completed_data_processing, '(Re)Processing', 'completion_date', 'Completion date')
                                        }
                                        {
                                            this.getTab(this.state.completed_data_packaging, 'Packaging/Formatting', 'completion_date', 'Completion date')
                                        }
                                    </>
                                },
                                {
                                    label: <><i className="fas fa-clock" /> Planned Projects</>,
                                    content: <div className="tab-padding">
                                        <LoadingData
                                            loading={this.state.loading} no_data={!this.state.planned_data}
                                            no_data_message="No planned projects to show"
                                        >

                                            {
                                                this.state.planned_data &&
                                                <DataTable
                                                    show_all
                                                    data={this.state.planned_data}
                                                    fixed_width={{
                                                        'collection': this.percentage_size,
                                                        'consolidation': this.percentage_size,
                                                        'integration': this.percentage_size,
                                                        'processing': this.percentage_size,
                                                        'repatriation': this.percentage_size,
                                                    }}
                                                    headers={[
                                                        {
                                                            label: 'Project',
                                                            key: 'name'
                                                        },
                                                        {
                                                            label: 'Planned start date',
                                                            key: "planned_start_date"
                                                        },
                                                        {
                                                            label: 'Planned completion date',
                                                            key: "planned_completion_date"
                                                        }
                                                    ]}
                                                    field_output={{
                                                        'name': (p) => <div
                                                            className="project-name"
                                                            onClick={() => { push_history(`/project/${p.name}`) }}
                                                        >
                                                            {p.name}
                                                        </div>,
                                                        'planned_start_date': (p) => this.date_column(p, "planned_start_date"),
                                                        'planned_completion_date': (p) => this.date_column(p, "planned_completion_date")

                                                    }}
                                                    operations={isAdmin() ? this.get_operations : undefined}
                                                    sort_columns={{
                                                        'name': { filter: 'alphabetical' },
                                                        'planned_start_date': { filter: 'date' },
                                                        'planned_completion_date': { filter: 'date' },
                                                    }}
                                                />
                                            }
                                        </LoadingData>
                                    </div>
                                },
                                {
                                    label: <><i className="fas fa-clipboard-list" /> Inputs & issues</>,
                                    content: <div >
                                        <DSIIssues />
                                    </div>
                                }
                            ]}
                        />
                    </div>
                </div>
            </Page>
        );
    }


    delete = async (data: any) => {
        if (window.confirm(`Are you sure you want to remove ${data.name} ?`)) {
            try {
                await request(`${API_URL}/api/v1/projects/${data.id}`, {
                    method: 'delete'
                })

                this.fetch();

                create_toast({ type: 'success', message: `Successfully removed project ${data.name}` });
            }
            catch (e) {
                axiosErrorHandler(e, {
                    functionName: 'delete'
                })
                toast_request_error(e);
            }
        }
    }




};


export default Projects;
